import { render, staticRenderFns } from "./activeChatSidebars.vue?vue&type=template&id=60b90b76&"
import script from "./activeChatSidebars.vue?vue&type=script&lang=ts&"
export * from "./activeChatSidebars.vue?vue&type=script&lang=ts&"
import style0 from "./activeChatSidebars.vue?vue&type=style&index=0&id=60b90b76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports